module.exports = __webpack_public_path__ + "img/brands-barilla.png?ecce057de94b2d41d35c1c4d985adf11";